import React, { useEffect } from "react";
import PropTypes from "prop-types";

const RctFrameWrapper = ({form, onSave}) => {

  useEffect(
    () => {
      if (onSave) {
        window.addEventListener("message", handleMessage, false);
      }
      return () => {
        if (onSave) {
          window.removeEventListener("message", handleMessage, false);
        }
      };
    }, []
  );

  const handleMessage = event => {
    if (onSave && event?.data === "CALCSAVED") {
      onSave();
    }
  };

  return (
    <iframe className="CoverageAOutProvider" frameBorder="0" id={`${form.originalPayload}}`} name={`${form.originalPayload}}`} src={`${form.src}`} height="975px" width="750px" />
  );
};

RctFrameWrapper.propTypes = {
  form: PropTypes.object,
  onSave: PropTypes.func, // Function that will be called if the calc posts a message when saved (Currently only supported in non-PNX RCT High Value)
};

export default RctFrameWrapper;